import React from 'react';
import PropTypes from 'prop-types';
import OfficePageCitiesLetters from './OfficePageCitiesLetters/OfficePageCitiesLetters';
import OfficePageCitiesList from './OfficePageCitiesList/OfficePageCitiesList';
import {
  groupByFirstLetter,
  groupFirstLettersInRows
} from 'redux/models/offices/model';
import first from 'lodash/first';

const OfficePageCities = ({ cities, activeCity, setActiveCity, activeCountry }) => {
  const firstRender = React.useRef(true);
  const groupedCities = React.useMemo(() => groupByFirstLetter(cities), [cities]);

  const groupedFirstLetters = React.useMemo(() => groupFirstLettersInRows(cities), [cities]);
  const activeLetterInitial = React.useMemo(() => (
    activeCity ? activeCity[0] : first(cities)[0]
  ), [activeCity, cities]);
  const [activeLetter, setActiveLetter] = React.useState(activeLetterInitial);

  React.useEffect(() => {
    if (!firstRender.current) {
      setActiveLetter(activeCity[0]);
    }
    firstRender.current = false;
  }, [setActiveLetter, activeCity]);

  const setActiveLetterHandle = (letter) => {
    const citiesByFirstLetter = groupedCities[letter];
    setActiveCity(first(citiesByFirstLetter));
    setActiveLetter(letter);
  };

  return (
    <>
      {groupedFirstLetters.map((groupedLetters) => (
        <React.Fragment key={groupedLetters}>
          <OfficePageCitiesLetters
            setActiveLetter={setActiveLetterHandle}
            activeLetter={activeLetter}
            letters={groupedLetters}
            activeCountry={activeCountry}
          />
          {groupedLetters.includes(activeLetter) && (
            <OfficePageCitiesList
              activeLetter={activeLetter}
              activeCity={activeCity}
              setActiveCity={setActiveCity}
              cities={groupedCities[activeLetter]}
            />
          )}
        </React.Fragment>
      ))}
    </>
  );
};

OfficePageCities.propTypes = {
  activeCountry: PropTypes.string,
  cities: PropTypes.array,
  activeCity: PropTypes.string,
  setActiveCity: PropTypes.func,
};

export default OfficePageCities;
